import axios from 'axios';

import BaseModel from './_base-model';
import store from '../../stores';
import config from '@config';
import Constants from '@constants';
/**
 * @param {String} url request url
 * @param {Object} params request params
 * 例如:
 *  url: /api/:id/delete?from=:from&end=:end
 *  params: {
 *    id: 12345,
 *    from: '2018-05-09',
 *    end: '2018-05-10',
 *    refresh: true,
 *    state: 'powerOn'
 *  }
 *
 * 结果是: /api/12345/delete?from=2018-05-09&end=2018-05-10&refresh=true&state=powerOn
 */
const fetchSuccess = (ret) => {
  return ret;
};

const fetchError = (response = {}, options = {}) => {
  const errorBody = response.data;
  if (errorBody.code) {
    errorBody.code = isNaN(+errorBody.code) ? errorBody.code : +errorBody.code;
  }
  if (!options.preventDefaultNotify) {
    store.commit(store.VX_TYPES.GLOBAL.FETCH_ERROR, errorBody);
  }
  return Promise.reject(errorBody);
};

axios.defaults.baseURL = config.BASE_URL;
if (!config.IS_LOCAL) {
  axios.defaults.withCredentials = true;
}

class VModelHttp extends BaseModel {
  constructor(options = {}) {
    super({
      engine: Constants.GLOBAL_KEYS.MODEL_ENGINE.HTTP,
      iLike: options.iLike
    });

    _assert(this.constructor !== VModelHttp, '禁止实例化 VModelHttp, 请继承 VModelHttp 实现自己的 Model 类');

    _assert(options.url, '当使用 HTTP 时, 请指定请求路径 url');
    this.baseURL = options.baseURL || config.BASE_URL;
    this.url = options.url;
  }
  _wrapGetOptions(options) {
    return { // get()
      ...options,
      method: 'get',
      aseURL: this.baseURL,
      url: this.url + '?t=' + new Date().getTime()
    };
  }
  _wrapPostOptions(options) {
    return { // post()
      method: 'post',
      ...options,
      aseURL: this.baseURL,
      url: this.url
    };
  }
  get(options = {}) {
    const _options = this._wrapGetOptions({
      options
    });
    options.method = 'get';
    return axios.request(_options).then(ret => this.parseData(fetchSuccess(ret))).catch(err => fetchError(err.response, options));
  }
  post(options = {}) {
    const _options = this._wrapPostOptions(options);
    return axios.request(_options);
  }
};

export default VModelHttp;



// WEBPACK FOOTER //
// ./src/extend/model/_remote-model.js